/* 
 * Filter gets label from options by value
 */

app.filter("_filtersOptionLabel",function($filter){
    
    return function(val,options){
      
      return $filter('_filtersOption')(val,options,"label");
        
    };
    
    
});


app.filter("_filtersOption",function(){
    
    return function(val,options,option){
      
      var el=options.find(function(el){
          
          return el.value==val;
          
      });
      
      return el?el[option]:"";
        
    };
    
    
});

